import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
import { LineColorShades } from '../lineColors/lineColorShades/LineColorShades';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, Row, Col, HelpBlock } from 'react-bootstrap'

export class LineColorForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showLineColorShades: false,
        }
    }

    handleSaveShades = () => {
        this.props.onSave();
        this.setState({ showLineColorShades: false });
    };

    render() {
        let { lineColor, nameInputError, backColorInputError, paperColorInputError, foreColorInputError, title } = this.props;

        return (
            typeof lineColor !== 'undefined'
                ?
                <Modal show={this.props.show}>
                    <Modal.Header>
                        <Modal.Title>
                            {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <FormGroup controlId="formNome" validationState={nameInputError} >
                                <ControlLabel>Nome</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={lineColor.name}
                                    placeholder="Introduza o Nome"
                                    onChange={(e) => this.props.onChangeValue(e, 'name')}
                                />
                                {nameInputError !== null
                                    ?
                                    <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                    :
                                    null
                                }
                            </FormGroup>

                            <Row>
                                <Col sm={6}>
                                    <FormGroup controlId="formCorFundo" validationState={backColorInputError}>
                                        <ControlLabel>
                                            Cor fundo
                                        </ControlLabel>
                                        <SketchPicker className="sketch-picker"color={lineColor.backColor} onChangeComplete={(color) => this.props.onChangeValue(color, 'backColor')} />
                                        {backColorInputError !== null
                                            ?
                                            <HelpBlock> Defina uma cor de fundo. </HelpBlock>
                                            :
                                            null
                                        }
                                    </FormGroup>
                                </Col>
                                <Col sm={6}>
                                    <FormGroup controlId="formCorPapel" validationState={paperColorInputError}>
                                        <ControlLabel>
                                            Cor papel
                                        </ControlLabel>
                                        <SketchPicker className="sketch-picker" color={lineColor.paperColor} onChangeComplete={(color) => this.props.onChangeValue(color, 'paperColor')} />
                                        {paperColorInputError !== null
                                            ?
                                            <HelpBlock> Defina uma cor para papel. </HelpBlock>
                                            :
                                            null
                                        }
                                    </FormGroup>
                                </Col>
                                <Col sm={6}>
                                    <FormGroup controlId="formCorTexto" validationState={foreColorInputError}>
                                        <ControlLabel>Cor texto</ControlLabel>
                                        <SketchPicker className="sketch-picker" color={lineColor.foreColor} onChangeComplete={(color) => this.props.onChangeValue(color, 'foreColor')} />
                                        {foreColorInputError !== null
                                            ?
                                            <HelpBlock> Defina uma cor para o texto. </HelpBlock>
                                            :
                                            null
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <ButtonToolbar>
                                <Button onClick={this.props.onSave}>GUARDAR</Button>
                                <Button onClick={this.props.onHide}>CANCELAR</Button>
                            </ButtonToolbar>

                            <ButtonToolbar>
                                <Button
                                    onClick={() => this.setState({
                                        showLineColorShades: true,
                                        lineColorSelected: this.props.lineColor
                                    })}
                                >
                                    TONALIDADES COR FUNDO
                                </Button>
                            </ButtonToolbar>
                        </div>

                        <LineColorShades
                            show={this.state.showLineColorShades}
                            onHide={() => this.setState({ showLineColorShades: false })}
                            lineColorSelected={this.props.lineColor}
                            setLineColorSelected={this.props.setLineColorSelected}
                            onCreateShadeValue={this.props.onCreateShadeValue}
                            onAddShade={this.props.onAddShade}
                            onEditShadeValue={this.props.onEditShadeValue}
                            onRemoveShadeValue={this.props.onRemoveShadeValue}
                            onSaveShades={this.handleSaveShades}
                        />

                    </Modal.Body>
                </Modal >
                : null
        );
    }
}
